<template>
  <div class="-mt-2 mb-4 badge-container">
    <link-wrapper :href="link" type="button" target="_blank">
      <div class="badge flex flex-row items-center mt-4 text-xs h-4">
        <div class="rounded-l rounded-r-0 text-[#d3d3d3] bg-[#24292f] py-0.5 px-1">
          <v-icon class="github-icon" name="github-mono" />
        </div>
        <div
          id="githubRepoName"
          class="tracking-normal py-0.5 px-2 rounded-t-0 rounded-r h-full bg-[#d3d3d3] text-[#2429f] font-normal"
        >
          {{ name }}
        </div>
      </div>
    </link-wrapper>
  </div>
</template>

<script setup lang="ts">
import { VIcon } from '@vonage/vivid-vue';
import { computed } from 'vue';
import { LinkWrapper } from '@/components/markdown/widgets/index';

const props = defineProps({
  link: { type: String, required: true },
});

const name = computed(() => props.link.replace('https://github.com/', ''));
</script>

<style scoped lang="scss">
.badge-container {
  a {
    color: var(--vvd-color-cta-600);
  }
}

.github-icon {
  color: var(--vvd-color-canvas);
  margin-top: -1px;
  --vvd-icon-size: 14px;
}
</style>
